import {
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
} from 'firebase/auth';
import { firebaseAuth } from '../lib/firebase';
import { useAuthStore } from '../stores/authStore';
import { queryClient } from '../lib/queryClient';

const googleProvider = new GoogleAuthProvider();

export function useAuth() {
  const { user, loading } = useAuthStore();

  const loginWithEmail = async (email: string, password: string) => {
    return signInWithEmailAndPassword(firebaseAuth, email, password);
  };

  const signupWithEmail = async (email: string, password: string) => {
    return createUserWithEmailAndPassword(firebaseAuth, email, password);
  };

  const loginWithGoogle = async () => {
    return signInWithPopup(firebaseAuth, googleProvider);
  };

  const logout = async () => {
    await signOut(firebaseAuth);
    queryClient.clear();
    sessionStorage.clear();
  };

  const getIdToken = async () => {
    return user?.getIdToken() ?? null;
  };

  return {
    user,
    loading,
    isAuthenticated: !!user,
    loginWithEmail,
    signupWithEmail,
    loginWithGoogle,
    logout,
    getIdToken,
  };
}
